import { Splide } from '@splidejs/splide';

export const INIT_sliders = (refresh = false) => {
    const sliders = [...document.getElementsByClassName('js-slider')];

    if (sliders) {
        sliders.forEach((item) => {

            // Section - Banner Carousel
            if (item.classList.contains('section--banner-carousel--slider')) {
                const arrowPrev = item.dataset.prev;
                const arrowNext = item.dataset.next;

                let slider = new Splide(item.querySelector('.splide'), {
                    rewind: true,
                    arrows: false,
                    pagination: true,
                    gap: 0,
                });

                slider.on('overflow', (isOverflow) => {
                    if (isOverflow) {
                        document.getElementById(arrowPrev).disabled = false;
                        document.getElementById(arrowNext).disabled = false;
                    } else {
                        document.getElementById(arrowPrev).disabled = true;
                        document.getElementById(arrowNext).disabled = true;
                    }
                });

                if (refresh) {
                    slider.mount();
                    slider.refresh();
                } else {
                    slider.mount();
                }

                window.addEventListener('click', (event) => {
                    event.target.blur();

                    if (event.target.id === arrowPrev) {
                        slider.go('<');
                    }

                    if (event.target.id === arrowNext) {
                        slider.go('>');
                    }
                });
            }

            // Section - Collections / Reviews
            if (item.classList.contains('section--collections-reviews--slider')) {
                const arrowPrev = item.dataset.prev;
                const arrowNext = item.dataset.next;

                let slider = new Splide(item.querySelector('.splide'), {
                    rewind: true,
                    arrows: false,
                    pagination: false,
                    perPage: 4,
                    perMove: 1,
                    gap: '24px',
                    breakpoints: {
                        769: {
                            rewind: false,
                            gap: '12px',
                            fixedWidth: 224,
                            focus: 'center',
                            padding: {
                                left: 24,
                                right: 24,
                            },
                        },
                        1024: {
                            perPage: 3,
                        },
                        1220: {
                            perPage: 2,
                        },
                        1440: {
                            perPage: 3,
                        },
                    },
                });

                slider.on('overflow', (isOverflow) => {
                    if (isOverflow) {
                        document.getElementById(arrowPrev).disabled = false;
                        document.getElementById(arrowNext).disabled = false;
                    } else {
                        document.getElementById(arrowPrev).disabled = true;
                        document.getElementById(arrowNext).disabled = true;
                    }
                });

                if (refresh) {
                    slider.mount();
                    slider.refresh();
                } else {
                    slider.mount();
                }

                window.addEventListener('click', (event) => {
                    event.target.blur();

                    if (event.target.id === arrowPrev) {
                        slider.go('<');
                    }

                    if (event.target.id === arrowNext) {
                        slider.go('>');
                    }
                });
            }

            // Section - Videos Carousel
            if (item.classList.contains('section--videos-carousel--slider')) {
                const arrowPrev = item.dataset.prev;
                const arrowNext = item.dataset.next;

                let slider = new Splide(item.querySelector('.splide'), {
                    rewind: true,
                    arrows: false,
                    pagination: false,
                    perPage: 4,
                    perMove: 1,
                    gap: '48px',
                    breakpoints: {
                        769: {
                            rewind: false,
                            gap: '12px',
                            fixedWidth: 260,
                            focus: 'center',
                            padding: {
                                left: 24,
                                right: 24,
                            },
                        },
                        1220: {
                            perPage: 3,
                        },
                    },
                });

                slider.on('overflow', (isOverflow) => {
                    if (isOverflow) {
                        document.getElementById(arrowPrev).disabled = false;
                        document.getElementById(arrowNext).disabled = false;
                    } else {
                        document.getElementById(arrowPrev).disabled = true;
                        document.getElementById(arrowNext).disabled = true;
                    }
                });

                if (refresh) {
                    slider.mount();
                    slider.refresh();
                } else {
                    slider.mount();
                }

                window.addEventListener('click', (event) => {
                    event.target.blur();

                    if (event.target.id === arrowPrev) {
                        slider.go('<');
                    }

                    if (event.target.id === arrowNext) {
                        slider.go('>');
                    }
                });
            }
        });
    }
};
